import React, { useState } from 'react';
import './ContactPage.css';
import api from '../api';
import SEO from '../components/SEO';

function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', mobile: '', address: '', message: '' });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'नाम आवश्यक है';
    if (!form.email.trim() || !/^\S+@\S+\.\S+$/.test(form.email)) e.email = 'वैध ईमेल डालें';
    if (!form.mobile.trim() || !/^\d{10,}$/.test(form.mobile)) e.mobile = 'सही मोबाइल नंबर दें (10+ अंक)';
    if (!form.message.trim()) e.message = 'संदेश आवश्यक है';
    return e;
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length) return;

    try {
      setSubmitting(true);
      const res = await api.post('/api/contact', form);
      if (res.data && res.data.success) {
        setSuccess('हमने आपका संदेश प्राप्त कर लिया है। हम जल्द संपर्क करेंगे।');
        setForm({ name: '', email: '', mobile: '', address: '', message: '' });
      } else {
        setSuccess('कुछ गलती हुई — कृपया पुन: प्रयास करें');
      }
    } catch (err) {
      console.error(err);
      setSuccess('सबमिट करने में त्रुटि हुई।');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* SEO Meta Tags */}
      <SEO
        title="संपर्क करें - RR NEWS TV FASTEST UPDATE"
        description="RR NEWS TV FASTEST UPDATE से संपर्क करें। हमें अपने सुझाव, प्रश्न या फ़ीडबैक भेजें।"
        keywords="संपर्क, contact, RR NEWS TV FASTEST UPDATE, email, phone"
        url="/contact"
        type="website"
      />
      
      <div id="content-start" className="container contact-container">
        <h2 className="page-title">संपर्क करें</h2>

        <div className="contact-card">
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="row">
              <label>नाम</label>
              <input name="name" value={form.name} onChange={handleChange} />
              {errors.name && <div className="field-error">{errors.name}</div>}
            </div>

            <div className="row">
              <label>ईमेल</label>
              <input name="email" value={form.email} onChange={handleChange} />
              {errors.email && <div className="field-error">{errors.email}</div>}
            </div>

            <div className="row">
              <label>मोबाइल नंबर</label>
              <input name="mobile" value={form.mobile} onChange={handleChange} />
              {errors.mobile && <div className="field-error">{errors.mobile}</div>}
            </div>

            <div className="row">
              <label>पता</label>
              <input name="address" value={form.address} onChange={handleChange} />
            </div>

            <div className="row">
              <label>संदेश</label>
              <textarea name="message" value={form.message} onChange={handleChange} rows={6} />
              {errors.message && <div className="field-error">{errors.message}</div>}
            </div>

            <div className="actions">
              <button type="submit" className="btn-submit" disabled={submitting}>{submitting ? 'सबमिट कर रहे हैं...' : 'सबमिट करें'}</button>
            </div>
          </form>

          {success && (
            <div className="success-popup" role="status">
              <div className="success-inner">
                <p>{success}</p>
                <button onClick={() => setSuccess(null)} className="close">ठीक है</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContactPage;


